import { render, staticRenderFns } from "./StepsFirst.vue?vue&type=template&id=967dcab8&scoped=true"
import script from "./StepsFirst.vue?vue&type=script&lang=js"
export * from "./StepsFirst.vue?vue&type=script&lang=js"
import style0 from "./StepsFirst.vue?vue&type=style&index=0&id=967dcab8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967dcab8",
  null
  
)

export default component.exports